import React from 'react';

/**
 * SocialStack — Visual artwork for the "Gestão de Redes Sociais" card.
 * Stacked, floating glass tiles with Instagram, Facebook and Google brand icons.
 * Pure SVG / CSS — no external assets needed.
 */
const SocialStack = () => {
  return (
    <div className="absolute inset-0 flex items-start justify-center overflow-hidden pt-8">
      {/* Ambient backdrop */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1a0d2e] via-[#0A0A0A] to-[#0d1f2e]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_30%,rgba(225,48,108,0.18)_0%,rgba(0,0,0,0)_55%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_40%,rgba(24,119,242,0.12)_0%,rgba(0,0,0,0)_50%)]" />

      {/* Floating tiles cluster */}
      <div className="relative w-[300px] h-[200px]">
        {/* Instagram tile - top left */}
        <div
          className="absolute top-2 left-2 w-[78px] h-[78px] rounded-2xl shadow-2xl flex items-center justify-center"
          style={{
            background:
              'linear-gradient(135deg, #833AB4 0%, #C13584 30%, #E1306C 50%, #FD1D1D 70%, #F77737 90%, #FCAF45 100%)',
            transform: 'rotate(-8deg)',
            boxShadow: '0 18px 45px rgba(225, 48, 108, 0.55)',
          }}
        >
          <svg viewBox="0 0 24 24" className="w-9 h-9" fill="white">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
          </svg>
        </div>

        {/* TikTok tile - top right */}
        <div
          className="absolute top-0 right-2 w-[78px] h-[78px] rounded-2xl shadow-2xl flex items-center justify-center"
          style={{
            background: 'linear-gradient(135deg, #010101 0%, #161616 100%)',
            transform: 'rotate(8deg)',
            boxShadow: '0 18px 45px rgba(255, 0, 80, 0.35)',
          }}
        >
          {/* TikTok logo with double-exposure cyan/pink */}
          <svg viewBox="0 0 24 24" className="w-9 h-9" aria-label="TikTok">
            {/* Cyan offset */}
            <path
              d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.07A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z"
              fill="#25F4EE"
              transform="translate(-1.5, 1)"
            />
            {/* Pink offset */}
            <path
              d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.07A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z"
              fill="#FE2C55"
              transform="translate(1.5, -1)"
            />
            {/* White main */}
            <path
              d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.07A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z"
              fill="white"
            />
          </svg>
        </div>

        {/* Facebook tile - bottom left */}
        <div
          className="absolute bottom-0 left-5 w-[72px] h-[72px] rounded-2xl shadow-2xl flex items-center justify-center"
          style={{
            background: 'linear-gradient(135deg, #1877F2 0%, #0C5DCB 100%)',
            transform: 'rotate(-14deg)',
            boxShadow: '0 18px 45px rgba(24, 119, 242, 0.55)',
          }}
        >
          <svg viewBox="0 0 24 24" className="w-9 h-9" fill="white">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        </div>

        {/* Google tile - bottom right */}
        <div
          className="absolute bottom-0 right-5 w-[72px] h-[72px] rounded-2xl shadow-2xl flex items-center justify-center bg-white"
          style={{
            transform: 'rotate(12deg)',
            boxShadow: '0 18px 45px rgba(255, 255, 255, 0.22)',
          }}
        >
          <svg viewBox="0 0 24 24" className="w-9 h-9">
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              fill="#4285F4"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="#34A853"
            />
            <path
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              fill="#FBBC05"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              fill="#EA4335"
            />
          </svg>
        </div>

        {/* Sparkles */}
        <span className="absolute top-12 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-[#4ECDC4] opacity-70 animate-pulse" />
        <span className="absolute top-2 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#FE2C55] opacity-60 animate-pulse" style={{ animationDelay: '0.5s' }} />
        <span className="absolute bottom-3 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#1877F2] opacity-50 animate-pulse" style={{ animationDelay: '1s' }} />
      </div>
    </div>
  );
};

export default SocialStack;
